import { createListModalContainer } from 'factories/ListModal'
import actions from 'actions/lists'
import Component from 'components/Lists/Select'

export default createListModalContainer({ actions })(Component)
